import * as React from "react";

const FavoriteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <circle
      cx="32"
      cy="32"
      r="31"
      fill="#fff"
      stroke="#00003C"
      strokeWidth="2"
    ></circle>
    <path
      fill="#00003C"
      stroke="#00003C"
      d="M32 20.606a.8.8 0 0 1 .683.385l3.174 6.433.117.235.26.038 7.123 1.035a.75.75 0 0 1 .485 1.2l-.07.079-5.154 5.025-.188.183.044.26 1.217 7.094a.75.75 0 0 1-1.087.79l-6.372-3.35L32 39.89l-.232.123-6.372 3.35a.75.75 0 0 1-1.086-.79l1.215-7.095.045-.26-.188-.182-5.155-5.025a.752.752 0 0 1 .416-1.279l7.123-1.035.26-.038.117-.235 3.17-6.427a.8.8 0 0 1 .688-.39Z"
    ></path>
  </svg>
);

export default FavoriteIcon;
